import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VCard,[_c(VToolbar,{attrs:{"color":"primary","dark":"","flat":""}},[_c(VToolbarTitle,[_vm._v(_vm._s(_vm.$t('internal')))])],1),_c(VForm,{ref:"form"},[_c(VCardText,[_c(VTextarea,{staticClass:"mb-6",attrs:{"filled":"","hide-details":"auto","label":_vm.$t('notes')},model:{value:(_vm.spot.notes),callback:function ($$v) {_vm.$set(_vm.spot, "notes", $$v)},expression:"spot.notes"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }